(function(){
'use strict';
var OTHER_MAKE='Other make';var OTHER_MODEL='Other model';
var BUY_LABEL='Buy it now';
var VEHICLES={
'Abarth':['500','595','695','124 Spider','500e','600e'],
'Alfa Romeo':['Giulia','Giulietta','MiTo','Stelvio','Tonale','Junior'],
'Audi':['A1','A3','A4','A5','A6','A7','A8','e-tron','Q2','Q3','Q4 e-tron','Q5','Q7','Q8','Q8 e-tron','TT','RS3','RS6'],
'BMW':['1 Series','2 Series','3 Series','4 Series','5 Series','7 Series','i3','i4','i5','iX','iX1','iX3','X1','X2','X3','X4','X5','X6','X7','Z4'],
'BYD':['Atto 3','Dolphin','Seal','Seal U','Sealion 7'],
'Citroen':['C1','C3','C3 Aircross','C4','C4 X','C5 Aircross','C5 X','Berlingo','e-C4','SpaceTourer'],
'Cupra':['Born','Formentor','Leon','Ateca','Tavascan'],
'Dacia':['Sandero','Sandero Stepway','Duster','Jogger','Spring','Bigster'],
'DS':['DS 3','DS 4','DS 7','DS 9'],
'Fiat':['500','500X','500e','Panda','Tipo','Doblo','600'],
'Ford':['Fiesta','Focus','Puma','Kuga','EcoSport','Mondeo','Galaxy','S-Max','Mustang','Mustang Mach-E','Explorer','Ranger','Transit Custom','Tourneo Connect'],
'Genesis':['G70','G80','GV60','GV70','GV80'],
'Honda':['Jazz','Civic','HR-V','CR-V','ZR-V','e:Ny1','Honda e'],
'Hyundai':['i10','i20','i30','Bayon','Kona','Tucson','Santa Fe','IONIQ','IONIQ 5','IONIQ 6','INSTER'],
'Isuzu':['D-Max'],
'Jaguar':['XE','XF','F-Pace','E-Pace','I-Pace','F-Type'],
'Jeep':['Renegade','Compass','Avenger','Wrangler','Grand Cherokee'],
'Kia':['Picanto','Rio','Ceed','ProCeed','XCeed','Stonic','Niro','Sportage','Sorento','EV3','EV6','EV9'],
'Land Rover':['Defender','Discovery','Discovery Sport','Range Rover','Range Rover Sport','Range Rover Velar','Range Rover Evoque'],
'Lexus':['CT','IS','ES','NX','RX','UX','LBX','RZ'],
'Mazda':['Mazda2','Mazda3','Mazda6','CX-3','CX-30','CX-5','CX-60','CX-80','MX-5','MX-30'],
'Mercedes-Benz':['A-Class','B-Class','C-Class','CLA','E-Class','GLA','GLB','GLC','GLE','GLS','EQA','EQB','EQC','EQE','EQS','S-Class','V-Class','Vito'],
'MG':['MG3','MG4','MG5','ZS','HS','Cyberster','MG S5'],
'MINI':['Hatch','Clubman','Countryman','Convertible','Aceman','Electric'],
'Mitsubishi':['ASX','Eclipse Cross','Outlander','L200','Space Star'],
'Nissan':['Micra','Juke','Qashqai','X-Trail','Leaf','Ariya','Navara','Note'],
'Peugeot':['108','208','e-208','308','408','508','2008','3008','5008','Rifter'],
'Polestar':['Polestar 2','Polestar 3','Polestar 4'],
'Porsche':['Macan','Cayenne','Taycan','Panamera','911'],
'Renault':['Clio','Captur','Megane','Arkana','Austral','Kadjar','Scenic','Zoe','Symbioz','Renault 5'],
'SEAT':['Ibiza','Arona','Leon','Ateca','Tarraco'],
'Skoda':['Fabia','Scala','Octavia','Superb','Kamiq','Karoq','Kodiaq','Enyaq','Elroq'],
'Smart':['ForTwo','ForFour','#1','#3'],
'SsangYong / KGM':['Tivoli','Korando','Rexton','Musso','Torres'],
'Subaru':['Impreza','XV','Crosstrek','Forester','Outback','Solterra'],
'Suzuki':['Ignis','Swift','Vitara','S-Cross','Jimny','Across','Swace'],
'Tesla':['Model 3','Model Y','Model S','Model X'],
'Toyota':['Aygo','Aygo X','Yaris','Yaris Cross','Corolla','C-HR','RAV4','Prius','bZ4X','Land Cruiser','Hilux','Proace City'],
'Vauxhall':['Corsa','Astra','Mokka','Crossland','Grandland','Insignia','Frontera','Combo Life','Vivaro Life'],
'Volkswagen':['Up!','Polo','Golf','T-Cross','T-Roc','Taigo','Tiguan','Touareg','Passat','Arteon','Touran','ID.3','ID.4','ID.5','ID.7','ID. Buzz','Amarok','Caddy','Transporter'],
'Volvo':['XC40','EX30','XC60','XC90','EX90','V40','V60','V90','S60','S90']
};
function $(s,c){return (c||document).querySelector(s)}
function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
function opt(v,t){var o=document.createElement('option');o.value=v;o.textContent=t||v;return o}
function routeRoot(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/'}

function initVehicle(root){
 var make=$('[data-rv-make]',root),model=$('[data-rv-model]',root),year=$('[data-rv-year]',root);
 if(!make||make.dataset.ready)return;make.dataset.ready='1';
 var oMakeWrap=$('[data-rv-other-make]',root),oModelWrap=$('[data-rv-other-model]',root);
 var oMake=oMakeWrap&&$('input',oMakeWrap),oModel=oModelWrap&&$('input',oModelWrap);
 var ok=$('[data-rv-veh-ok]',root),okText=$('[data-rv-veh-ok-text]',root);
 Object.keys(VEHICLES).sort().forEach(function(k){make.appendChild(opt(k))});
 make.appendChild(opt(OTHER_MAKE));
 var y=new Date().getFullYear()+1;for(var i=y;i>=1995;i--){year.appendChild(opt(String(i)))}
 function fillModels(){
  model.innerHTML='';model.appendChild(opt('','Select model'));
  var list=VEHICLES[make.value]||[];
  list.forEach(function(m){model.appendChild(opt(m))});
  model.appendChild(opt(OTHER_MODEL));
  model.disabled=!make.value||make.value===OTHER_MAKE;
 }
 function sync(){
  var isOM=make.value===OTHER_MAKE;
  oMakeWrap.classList.toggle('is-on',isOM);
  oModelWrap.classList.toggle('is-on',isOM||model.value===OTHER_MODEL);
  [make,model,year].forEach(function(s){s.classList.toggle('is-set',!!s.value)});
  var v=getVehicle(root);
  if(v){ok.classList.add('is-on');okText.textContent='Perfect fit matched for your '+v.Year+' '+v.Make+' '+v.Model;root.classList.remove('is-error')}else{ok.classList.remove('is-on')}
  document.dispatchEvent(new CustomEvent('rv:vehicle',{detail:v}));
 }
 make.addEventListener('change',function(){fillModels();model.value='';sync()});
 model.addEventListener('change',sync);year.addEventListener('change',sync);
 if(oMake)oMake.addEventListener('input',sync);if(oModel)oModel.addEventListener('input',sync);
 fillModels();
 try{var saved=JSON.parse(sessionStorage.getItem('rvVehicle')||'null');if(saved&&saved.make){make.value=saved.make;fillModels();model.value=saved.model||'';year.value=saved.year||'';if(oMake)oMake.value=saved.om||'';if(oModel)oModel.value=saved.omd||''}}catch(e){}
 sync();
 root.addEventListener('change',function(){try{sessionStorage.setItem('rvVehicle',JSON.stringify({make:make.value,model:model.value,year:year.value,om:oMake?oMake.value:'',omd:oModel?oModel.value:''}))}catch(e){}});
}
function getVehicle(root){
 if(!root)return null;
 var make=$('[data-rv-make]',root),model=$('[data-rv-model]',root),year=$('[data-rv-year]',root);
 var oMake=$('[data-rv-other-make] input',root),oModel=$('[data-rv-other-model] input',root);
 var mk=make.value,md=model.value,yr=year.value;
 if(mk===OTHER_MAKE){mk=(oMake.value||'').trim();md=(oModel.value||'').trim()}
 else if(md===OTHER_MODEL){md=(oModel.value||'').trim()}
 if(!mk||!md||!yr)return null;
 return {Make:mk,Model:md,Year:yr};
}

function initGallery(g){
 var track=$('[data-rv-track]',g);if(!track)return;
 var slides=$$('.rv-gal__slide',track),thumbs=$$('[data-rv-thumb]',g),count=$('[data-rv-count]',g);
 function go(i){i=Math.max(0,Math.min(slides.length-1,i));track.scrollTo({left:slides[i].offsetLeft,behavior:'smooth'})}
 function cur(){return Math.round(track.scrollLeft/track.clientWidth)}
 var t;track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){var i=cur();thumbs.forEach(function(b,j){b.classList.toggle('is-active',j===i)});if(count)count.textContent=(i+1)+' / '+slides.length;var a=thumbs[i];if(a&&a.parentNode.scrollWidth>a.parentNode.clientWidth){a.parentNode.scrollTo({left:a.offsetLeft-20,behavior:'smooth'})}},60)},{passive:true});
 thumbs.forEach(function(b,j){b.addEventListener('click',function(){go(j)})});
 var p=$('[data-rv-prev]',g),n=$('[data-rv-next]',g);
 if(p)p.addEventListener('click',function(){var i=cur();go(i===0?slides.length-1:i-1)});
 if(n)n.addEventListener('click',function(){var i=cur();go(i===slides.length-1?0:i+1)});
}

function money(cents,fmt){
 var v=(cents/100).toFixed(2);
 return (fmt||'€{{amount}}').replace(/\{\{\s*amount\s*\}\}/,v).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,v.replace('.',','));
}

function initProduct(root){
 if(root.dataset.ready)return;root.dataset.ready='1';
 var veh=$('[data-rv-vehicle]',root);if(veh)initVehicle(veh);
 var gal=$('[data-rv-gallery]',root);if(gal)initGallery(gal);
 var fmt=root.dataset.moneyFormat;
 var idInput=$('[data-rv-variant-id]',root);
 var sets=$$('[data-rv-set]',root);
 var now=$('[data-rv-price-now]',root),was=$('[data-rv-price-was]',root),save=$('[data-rv-price-save]',root);
 var stickyPrice=$('[data-rv-sticky-price]',root),stickySet=$('[data-rv-sticky-set]',root);
 function selectSet(el){
  if(el.classList.contains('is-unavailable'))return;
  sets.forEach(function(s){s.classList.toggle('is-active',s===el);$('input',s).checked=s===el});
  idInput.value=el.dataset.id;
  var p=+el.dataset.price,c=+el.dataset.compare;
  if(now)now.textContent=money(p,fmt);
  if(was){was.textContent=c>p?money(c,fmt):'';was.style.display=c>p?'':'none'}
  if(save){if(c>p){save.textContent='SAVE '+Math.round((c-p)*100/c)+'%';save.style.display=''}else save.style.display='none'}
  if(stickyPrice)stickyPrice.textContent=money(p,fmt);
  if(stickySet)stickySet.textContent=el.dataset.title;
  try{var u=new URL(location.href);if(root.dataset.isProductPage==='true'){u.searchParams.set('variant',el.dataset.id);history.replaceState(null,'',u)}}catch(e){}
 }
 sets.forEach(function(s){s.addEventListener('click',function(e){e.preventDefault();selectSet(s)})});
 var qty=$('[data-rv-qty]',root);
 $$('[data-rv-qty-btn]',root).forEach(function(b){b.addEventListener('click',function(){var v=Math.max(1,(parseInt(qty.value,10)||1)+(+b.dataset.rvQtyBtn));qty.value=v})});
 var form=$('[data-rv-form]',root),btn=$('[data-rv-atc]',root),msg=$('[data-rv-msg]',root);
 var stickyBtn=$('[data-rv-sticky-btn]',root);
 var busy=false;
 function needVehicle(){
  veh.classList.remove('is-error');void veh.offsetWidth;veh.classList.add('is-error');
  var top=veh.getBoundingClientRect().top+window.pageYOffset-110;window.scrollTo({top:top,behavior:'smooth'});
  var first=$('select:not([disabled])',veh);var empty=$$('select,input',veh).filter(function(x){return x.offsetParent&&!x.disabled&&!x.value})[0];setTimeout(function(){(empty||first).focus({preventScroll:true})},400);
 }
 function setBusy(on,label){
  busy=on;
  [btn,stickyBtn].forEach(function(b){if(!b)return;b.disabled=on;if(on){b.dataset.label=b.innerHTML;b.innerHTML='Going to checkout…'}else if(b.dataset.label){b.innerHTML=b.dataset.label}});
 }
 function buyNow(){
  if(busy)return;
  var v=getVehicle(veh);if(!v){needVehicle();return}
  setBusy(true);msg.textContent='';
  var r=routeRoot();
  var body={items:[{id:+idInput.value,quantity:Math.max(1,parseInt(qty.value,10)||1),properties:v}]};
  fetch(r+'cart/clear.js',{method:'POST',headers:{Accept:'application/json'}})
  .catch(function(){})
  .then(function(){return fetch(r+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})})
  .then(function(res){return res.json().then(function(j){return {ok:res.ok,j:j}})})
  .then(function(res){
   if(!res.ok){throw new Error(res.j.description||res.j.message||'Could not start checkout, please try again.')}
   window.location.href=r+'checkout';
  }).catch(function(err){setBusy(false);msg.textContent=err.message});
 }
 window.addEventListener('pageshow',function(e){if(e.persisted)setBusy(false)});
 if(form)form.addEventListener('submit',function(e){e.preventDefault();buyNow()});
 var sticky=$('[data-rv-sticky]',root);
 if(sticky&&btn&&stickyBtn&&'IntersectionObserver' in window){
  var io=new IntersectionObserver(function(es){es.forEach(function(en){sticky.classList.toggle('is-on',!en.isIntersecting&&en.boundingClientRect.top<0)})},{threshold:0});io.observe(btn);
  stickyBtn.addEventListener('click',function(){if(getVehicle(veh))buyNow();else needVehicle()});
  function stickyLabel(ok){if(!busy)stickyBtn.textContent=ok?BUY_LABEL:'Select vehicle'}
  document.addEventListener('rv:vehicle',function(e){stickyLabel(!!e.detail)});
  stickyLabel(!!getVehicle(veh));
 }
}

function initReveal(){
 var els=$$('.rv-reveal:not(.is-in)');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
 var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target)}})},{rootMargin:'0px 0px -8% 0px'});
 els.forEach(function(e){io.observe(e)});
}
function initAll(){$$('[data-rv-product]').forEach(initProduct);initReveal()}
window.RevonInit=initAll;
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
document.addEventListener('shopify:section:load',function(){initAll()});
})();
